module.exports = {
          srcSet: __webpack_public_path__ + "ea5f3974.jpg"+" 700w"+","+__webpack_public_path__ + "5673059e.jpg"+" 1400w"+","+__webpack_public_path__ + "be901b7f.jpg"+" 2000w",
          images:[ {path: __webpack_public_path__ + "ea5f3974.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "5673059e.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "be901b7f.jpg",width: 2000,height: 1500}],
          src: __webpack_public_path__ + "ea5f3974.jpg",
          toString:function(){return __webpack_public_path__ + "ea5f3974.jpg"},
          
          width: 700,
          height: 525
        }